var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1359,
    height: 929,
    viewBox: "0 0 1359 929",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1686551892",
    clipPath: "url(#clip0_514_266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1686552834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M796.557 361.816C796.529 362.687 796.487 363.615 796.458 364.628C796.586 362.42 796.572 361.394 796.557 361.816Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M454.405 419.897C453.881 417.9 453.427 415.609 453.045 413.092C455.922 434.815 461.62 454.921 472.606 478.246C472.606 478.246 481.89 501.389 506.271 526.599C520.191 541.038 539.072 556.139 563.948 567.978C569.009 570.396 574.31 572.66 579.881 574.769C587.833 577.792 602.32 579.886 622.136 579.212C624.149 579.141 626.218 579.043 628.344 578.916C629.79 578.832 631.25 578.734 632.739 578.621C633.547 578.48 634.34 578.326 635.134 578.171C637.941 577.623 640.705 577.018 643.426 576.343C644.589 576.062 645.694 575.781 646.743 575.514C647.807 575.233 648.827 574.965 649.791 574.698C653.845 573.559 657.8 572.308 661.655 570.93C658.466 571.872 645.95 575.233 628.344 576.104C626.346 576.203 624.262 576.273 622.136 576.301C605.41 576.526 585.012 574.305 563.948 566.122C544.501 558.6 524.472 545.974 506.271 525.516C485.392 502.036 466.893 468.221 454.405 419.897V419.897Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M450.168 120V353.847C450.168 367.921 450.366 380.547 451.075 392.372C449.941 370.593 450.707 347.014 450.707 347.014V120.38C450.607 120.309 450.537 120.253 450.466 120.211C450.281 120.07 450.182 120 450.168 120Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1686552830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1686552829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M625.806 324.272V477.907C627.843 478.481 629.908 478.956 632.001 479.366C639.299 480.809 646.866 481.383 654.023 481.481C660.062 481.563 666.073 481.12 672.014 480.17V319.764L632.001 323.665L625.806 324.272V324.272Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M523.36 333.416C525.767 383.075 498 478 562.341 453.5V228.021L522.552 241.407C522.552 241.407 522.262 275.274 522.552 296.972C522.743 311.206 522.552 316.745 523.36 333.416Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M672.014 319.764V479.779C684.12 477.85 695.942 473.811 707.098 467.728V350.063L672.014 319.764V319.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M562.342 228V454C574.618 467.61 590.522 473.573 611.16 481.447C614.137 482.586 617.284 483.514 620.53 484.273C622.571 484.765 624.64 485.173 626.738 485.524V276.268L562.342 228Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M451.075 392.379C451.103 392.59 451.061 399.796 451.075 400.007C451.5 406.826 452.138 406.383 453.003 412.78C453.003 412.879 453.017 412.991 453.045 413.089C453.428 415.606 453.882 417.898 454.406 419.895C466.894 468.219 485.392 502.033 506.272 525.514C524.472 545.971 544.501 558.597 563.949 566.119C585.013 574.302 605.41 576.524 622.137 576.299C624.263 576.271 626.346 576.2 628.345 576.102C645.95 575.23 658.467 571.87 661.656 570.928C661.67 570.928 661.698 570.914 661.713 570.914C663.995 570.112 666.234 569.269 668.446 568.383C681.26 563.293 692.954 557.022 703.528 550.035C733.168 530.463 756.547 524.471 768.383 504.238C795.166 477.455 801.342 533.524 802.264 511.168C801.229 527.872 768.383 481.523 737.108 500.388C727.016 510.146 715.662 517.921 703.528 523.602C692.373 528.832 680.551 532.305 668.446 533.964C662.492 534.779 656.468 535.159 650.415 535.089C643.243 535.004 635.659 534.512 628.345 533.275C626.247 532.923 624.178 532.516 622.137 532.024C618.891 531.264 615.744 530.336 612.767 529.198C592.129 521.324 576.224 510.498 563.949 496.888C539.101 469.33 529.741 437.57 524.968 381.159C524.458 375.127 524.16 344.715 524.16 344.715V174.701C524.16 174.701 457.383 125.195 450.707 120.387V347.021C450.707 347.021 449.941 370.6 451.075 392.379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M392.999 172.514V385.032C392.999 387.31 393.042 389.658 393.127 392.048C395.99 475.228 448.437 533.662 506.27 562.203C523.776 570.836 541.764 576.728 559.015 579.75C560.673 580.046 562.318 580.299 563.948 580.538C585.493 583.701 605.707 582.689 622.135 580.369C624.276 580.074 626.345 579.75 628.344 579.413C630.711 579.019 632.979 578.598 635.133 578.162C638.11 577.557 640.874 576.938 643.426 576.334C644.588 576.053 645.694 575.771 646.743 575.504C647.806 575.223 648.826 574.956 649.79 574.689C657.175 572.664 661.683 570.977 662.363 570.71C662.25 570.738 662.037 570.808 661.711 570.907C661.697 570.907 661.669 570.921 661.655 570.921C658.465 571.863 645.949 575.223 628.344 576.095C626.345 576.193 624.261 576.264 622.135 576.292C605.409 576.517 585.011 574.295 563.948 566.112C544.5 558.59 524.471 545.964 506.27 525.507C485.391 502.026 466.496 469.758 454.405 419.887C453.88 417.891 453.427 415.599 453.044 413.082C453.016 412.984 453.001 412.871 453.001 412.773C452.094 406.994 451.499 400.119 451.116 393.005C451.116 392.794 451.074 392.372 451.074 392.372L450.705 347.014V120C450.705 120 450.62 120.07 450.464 120.211C450.393 120.281 450.294 120.366 450.166 120.478C444.326 125.708 392.999 172.346 392.999 172.514Z",
    fill: "#EBEFF2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M308.34 350.183C308.34 371.276 293.17 388.366 293.17 388.366C293.17 388.366 278.001 371.276 278.001 350.183C278.001 329.09 293.17 312 293.17 312C293.17 312 308.34 329.09 308.34 350.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M292.203 345.525H294.164V409.622H292.203V345.525Z",
    fill: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "large_fan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M1137.72 96.0469H1134.16L1130.51 370.111H1137.72H1144.93L1141.25 96.0469H1137.72Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M1134 96.1113H1132.52L1131 370.111H1134H1137L1135.47 96.1113H1134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M1146.71 92H1131.53C1129.58 92 1128 94.1328 1128 96.7836C1128 99.4344 1129.58 101.567 1131.53 101.567H1146.71C1148.66 101.567 1150.24 99.4344 1150.24 96.7836C1150.24 94.1328 1148.66 92 1146.71 92Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M1130.04 95.6797C1129.31 95.6797 1128.7 96.5024 1128.7 97.5078C1128.7 98.5133 1129.31 99.336 1130.04 99.336C1130.77 99.336 1131.38 98.5133 1131.38 97.5078C1131.38 96.5024 1130.77 95.6797 1130.04 95.6797Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M1130.04 92.6934C1128.09 92.6934 1126.5 94.8262 1126.5 97.477C1126.5 100.128 1128.09 102.261 1130.04 102.261C1131.99 102.261 1133.57 100.128 1133.57 97.477C1133.57 94.8262 1131.99 92.6934 1130.04 92.6934Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M1129.47 102.387C1129.53 104.642 1130.2 106.805 1131.45 108.694L1160.15 152.448C1160.7 153.301 1162.04 152.631 1161.68 151.686L1145.16 106.47C1144.61 104.947 1143.58 103.637 1142.27 102.723C1142.27 102.723 1132.88 95.4406 1132.39 95.2578L1129.29 95.7757L1129.47 102.387V102.387Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M1129.47 102.387C1129.53 104.642 1130.2 106.805 1131.45 108.694L1160.15 152.448C1160.7 153.301 1162.04 152.631 1161.68 151.686L1139.61 111.84C1139.61 111.84 1132.88 95.4406 1132.39 95.2578L1129.29 95.7757L1129.47 102.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M1133.74 76.1225C1132.7 77.3717 1132.06 78.8951 1131.94 80.51C1131.94 80.51 1130.32 92.2711 1130.41 92.7891L1132.43 95.2266L1138.09 91.7531C1140.01 90.5648 1141.57 88.889 1142.57 86.8781L1166.09 40.1386C1166.55 39.2245 1165.33 38.4324 1164.66 39.1941L1133.77 76.092L1133.74 76.1225Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M1065.91 91.2058C1064.91 91.2667 1064.81 92.7292 1065.82 92.912L1113.23 101.23C1114.81 101.504 1116.46 101.291 1117.92 100.59C1117.92 100.59 1128.92 96.1113 1129.32 95.7761L1130.41 92.8205L1124.59 89.6518C1122.61 88.5854 1120.39 88.0675 1118.14 88.2199L1065.91 91.2058V91.2058Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M1119.01 100.715C1117.13 101.498 1115.08 101.726 1113.05 101.357L1065.93 93.0033C1065.02 92.85 1065.06 91.454 1065.98 91.4169L1107.31 95.5368C1107.31 95.5368 1125.79 94.4904 1126.13 94.84L1126.13 97.34L1119.01 100.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M1138.44 92.117C1140.36 90.9368 1141.9 89.2746 1142.91 87.2482L1166.13 40.3402C1166.59 39.4386 1165.77 39.0512 1165.13 39.8401L1141.55 78.608C1141.55 78.608 1130.72 92.635 1130.8 93.1486L1132.8 95.5811L1138.44 92.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M1126.2 96.1961L1126.2 97.1101C1126.2 98.2984 1128 103.387 1129.95 103.387C1131.75 103.387 1133.7 98.1461 1133.7 97.1101L1133.7 96.1961C1133.7 94.825 1132.02 93.6976 1129.95 93.6976C1127.88 93.6976 1126.2 94.825 1126.2 96.1961Z",
    fill: "#EBEFF2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "small_fan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M1262.02 166.545H1259.37L1256.64 370H1262.02H1267.4L1264.65 166.545H1262.02Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M1259.25 166.594H1258.14L1257.01 370H1259.25H1261.49L1260.34 166.594H1259.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M1268.73 163.541H1257.41C1255.95 163.541 1254.77 165.124 1254.77 167.092C1254.77 169.06 1255.95 170.643 1257.41 170.643H1268.73C1270.18 170.643 1271.36 169.06 1271.36 167.092C1271.36 165.124 1270.18 163.541 1268.73 163.541Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M1256.29 166.273C1255.75 166.273 1255.29 166.884 1255.29 167.631C1255.29 168.377 1255.75 168.988 1256.29 168.988C1256.84 168.988 1257.29 168.377 1257.29 167.631C1257.29 166.884 1256.84 166.273 1256.29 166.273Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M1256.29 164.057C1254.84 164.057 1253.66 165.64 1253.66 167.608C1253.66 169.576 1254.84 171.159 1256.29 171.159C1257.75 171.159 1258.93 169.576 1258.93 167.608C1258.93 165.64 1257.75 164.057 1256.29 164.057Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fan_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M1255.87 171.253C1255.91 172.927 1256.41 174.533 1257.35 175.935L1278.76 208.416C1279.16 209.049 1280.16 208.552 1279.89 207.851L1267.57 174.284C1267.16 173.153 1266.39 172.18 1265.41 171.502C1265.41 171.502 1258.41 166.096 1258.05 165.96L1255.73 166.345L1255.87 171.253V171.253Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M1255.87 171.253C1255.91 172.927 1256.41 174.533 1257.35 175.935L1278.76 208.416C1279.16 209.049 1280.16 208.552 1279.89 207.851L1263.43 178.27C1263.43 178.27 1258.41 166.096 1258.05 165.96L1255.73 166.345L1255.87 171.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M1259.05 151.755C1258.28 152.683 1257.8 153.814 1257.71 155.013C1257.71 155.013 1256.51 163.743 1256.57 164.128L1258.07 165.937L1262.3 163.359C1263.73 162.477 1264.89 161.233 1265.64 159.74L1283.19 125.042C1283.53 124.364 1282.62 123.776 1282.12 124.341L1259.07 151.733L1259.05 151.755Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M1208.46 162.953C1207.71 162.998 1207.64 164.084 1208.39 164.22L1243.76 170.395C1244.94 170.598 1246.16 170.44 1247.26 169.92C1247.26 169.92 1255.46 166.595 1255.76 166.346L1256.57 164.152L1252.23 161.799C1250.76 161.008 1249.1 160.623 1247.41 160.736L1208.46 162.953V162.953Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M1248.06 170.012C1246.66 170.594 1245.14 170.763 1243.62 170.489L1208.47 164.288C1207.79 164.174 1207.82 163.138 1208.51 163.11L1239.34 166.169C1239.34 166.169 1253.13 165.392 1253.38 165.651L1253.38 167.507L1248.06 170.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M1262.56 163.629C1263.99 162.753 1265.14 161.519 1265.89 160.015L1283.21 125.192C1283.56 124.523 1282.94 124.235 1282.47 124.821L1264.88 153.601C1264.88 153.601 1256.8 164.014 1256.86 164.395L1258.36 166.201L1262.56 163.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M1253.43 166.656L1253.43 167.335C1253.43 168.217 1254.77 171.994 1256.23 171.994C1257.57 171.994 1259.02 168.104 1259.02 167.335L1259.02 166.656C1259.02 165.638 1257.77 164.801 1256.23 164.801C1254.68 164.801 1253.43 165.638 1253.43 166.656Z",
    fill: "#EBEFF2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M1058.08 374C1293.5 358.999 1359 369 1359 369V513H69V428.5C69 428.5 159.308 408.5 343.5 408.5C610 419 832.491 388.373 1058.08 374Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M183.086 365.016C183.086 389.331 160.263 409.032 160.263 409.032C160.263 409.032 137.44 389.331 137.44 365.016C137.44 340.7 160.263 321 160.263 321C160.263 321 183.086 340.7 183.086 365.016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M158.421 361.111H161.414V433.484H158.421V361.111Z",
    fill: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M122.789 382.973C122.789 402.293 108.895 417.946 108.895 417.946C108.895 417.946 95.0004 402.293 95.0004 382.973C95.0004 363.653 108.895 348 108.895 348C108.895 348 122.789 363.653 122.789 382.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M108.01 378.707H109.806V437.415H108.01V378.707Z",
    fill: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M777.733 508.948C143.877 379.489 0 454.756 0 454.756V944H3335C3335 944 2712.33 476.85 2236.33 476.85C1559.19 476.85 1628.76 701.633 777.669 508.913L777.733 508.948Z",
    fill: "#EBEFF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1359,
    height: 929,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBg);
export default __webpack_public_path__ + "static/media/wallet_bg.9df85dc669b56b4de645ec2687431050.svg";
export { ForwardRef as ReactComponent };